import Plyr from "plyr";
import "../../../node_modules/plyr/dist/plyr.css";

import { addElementEvents, removeElementEvents } from "../utils/events";
import { uid } from "../utils/data";
import { hasClass, addClass } from "../utils/dom";
import data from "../data";

const removeModal = () => {
  var element = document.getElementById("ptw-modal-video-wrapper");
  element && element.parentNode.removeChild(element);
};

const initModal = (tag) => {
  removeModal();
  let modal = document.createElement("div");
  modal.id = "ptw-modal-video-wrapper";
  modal.innerHTML = `
        <div class="modalWindow modal-video">
          <div class="modalWindow-container">
            <div class="modalWindow-video-container">
              <div class="modalWindow-video">
              ${tag}
              </div>
              <a class="close" role="button" data-dismiss="modal">
                <span aria-hidden="true" class="mbri-close mbr-iconfont closeModal"></span>
                <span class="sr-only">Close</span>
              </a>
            </div>
          </div>
        </div>
  `;
  document.body.appendChild(modal);

  addElementEvents("#ptw-modal-video-wrapper .close", ["click"], removeModal);

  const player = new Plyr("#player", { autoplay: true });
};

const initVideo = (element) => {
  let tag = "";
  let src = element.getAttribute("data-src");
  if (!src || !src.length) return;

  var parsedUrl = src.match(
    /(http:\/\/|https:\/\/|)?(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
  );

  if (src.indexOf("youtu") !== -1) {
    src = "https://youtube.com/embed/" + parsedUrl[6] + "?rel=0&enablejsapi=1";
    tag = `<div id="player" data-plyr-provider="youtube" data-plyr-embed-id="${parsedUrl[6]}"></div>`;
  } else if (src.indexOf("vimeo") !== -1) {
    src = "https://player.vimeo.com/video/" + parsedUrl[6] + "?autoplay=0&loop=0";
    tag = `<div id="player" data-plyr-provider="vimeo" data-plyr-embed-id="${parsedUrl[6]}"></div>`;
  } else if (src.indexOf(".mp4") !== -1) {
    tag = `<video id="player" playsinline controls><source src="${src}" type="video/mp4" /></video>`;
  } else if (src.indexOf(".webm") !== -1) {
    tag = `<video id="player" playsinline controls><source src="${src}" type="video/webm" /></video>`;
  }

  if (tag && tag.length) {
    addElementEvents(element, ["click"], () => {
      initModal(tag);
    });
  }
};

const initVideoBlock = (element) => {
  let tag = "";
  let src = element.getAttribute("data-src");
  let autoplay = element.getAttribute("data-autoplay") === "true";
  let muted = element.getAttribute("data-muted") === "true";
  let loop = element.getAttribute("data-loop") === "true";
  let hidecontrols = element.getAttribute("data-hidecontrols") === "true";
  let quality = parseInt(element.getAttribute("data-quality") || "576", 10);
  let id = uid();
  if (!src || !src.length) return;

  var parsedUrl = src.match(
    /(http:\/\/|https:\/\/|)?(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
  );

  if (src.indexOf("youtu") !== -1) {
    src = "https://youtube.com/embed/" + parsedUrl[6] + "?rel=0&enablejsapi=1";
    tag = `<div id="${id}" data-plyr-provider="youtube" data-plyr-embed-id="${parsedUrl[6]}"></div>`;
  } else if (src.indexOf("vimeo") !== -1) {
    src = "https://player.vimeo.com/video/" + parsedUrl[6] + "?autoplay=0&loop=0";
    tag = `<div id="${id}" data-plyr-provider="vimeo" data-plyr-embed-id="${parsedUrl[6]}"></div>`;
  } else if (src.indexOf(".mp4") !== -1) {
    tag = `<video id="${id}" playsinline controls><source src="${src}" type="video/mp4" /></video>`;
  } else if (src.indexOf(".webm") !== -1) {
    tag = `<video id="${id}" playsinline controls><source src="${src}" type="video/webm" /></video>`;
  }

  if (tag && tag.length) {
    hidecontrols && addClass(element, "hidecontrols");
    element.data = {
      src,
      tag,
      id,
      autoplay,
      muted,
      loop,
      quality,
      target: element.querySelector(".video-wrapper") || element,
      image: element.querySelector(".video-wrapper .image-wrapper"),
    };

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0.0],
    };

    const observePlayer = (entries) => {
      if (entries && entries.length) {
        if (entries[0].isIntersecting) {
          if (!element.player && (!element.data.image || element.data.autoplay || entries[0].autoplay)) {
            element.data.target.innerHTML = element.data.tag;
            element.player = new Plyr("#" + element.data.id, {
              loop: { active: loop },
              autoplay,
              muted,
              // quality: { default: quality || 1080 },
            });
            element.player.on("ready", (event) => {
              (element.data.image || element.data.autoplay || entries[0].autoplay) && element.player.play();
              if (muted && element.player) {
                element.player.muted = true;
              }
              if (quality && element.player) {
                element.player.quality = quality;
              }
            });
          } else {
            element.player && (element.data.autoplay || entries[0].autoplay) && element.player.play();
            if (muted && element.player) {
              element.player.muted = true;
            }
            if (quality && element.player) {
              element.player.quality = quality;
            }
          }
        } else {
          element.player && element.player.pause();
        }
      }
      if (element.player) {
        console.log(element.data, element.player.isHTML5);
      }
    };

    let observer = new IntersectionObserver(observePlayer, options);

    observer.observe(element);

    if (element.data.image) {
      addElementEvents(element.data.image, ["click"], () => {
        observePlayer([{ isIntersecting: true, autoplay: true }]);
      });
    }
  }
};

const initVideoCTA = () => {
  let elements = document.querySelectorAll(".ptw-video-cta[data-src]");
  if (elements) {
    Array.prototype.forEach.call(elements, (element) => {
      initVideo(element);
    });
  }

  elements = document.querySelectorAll(".ptw-text-video[data-src]");
  if (elements) {
    Array.prototype.forEach.call(elements, (element) => {
      initVideoBlock(element);
    });
  }
};

export default initVideoCTA;
